import { Component, inject, OnInit, signal } from '@angular/core';
import { AccomodationViewComponent } from '../accomodation-view/accomodation-view.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccomodationService } from 'src/app/services/accomodation.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogWarningConfirmComponent } from 'src/app/components/dialog-warning-confirm/dialog-warning-confirm.component';
import { IAccommodationOfferShort } from 'src/app/interfaces/interface';
import { catchError, map, of, tap } from 'rxjs';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-accomodation',
  imports: [AccomodationViewComponent, MatSnackBarModule],
  standalone: true,
  templateUrl: './accomodation.component.html',
  styleUrl: './accomodation.component.scss',
})
export class AccomodationComponent implements OnInit {
  private accomService = inject(AccomodationService);
  private activateRoute = inject(ActivatedRoute);
  private router = inject(Router);
  public caseToken = signal<string>('');
  public snackBar = inject(MatSnackBar);

  public isErrorRequest = signal<boolean>(false);

  public errorMessage = signal<string>('');

  readonly dialog = inject(MatDialog);
  readonly confirmedOffer = signal<IAccommodationOfferShort | null>(null);

  public offer = signal<IAccommodationOfferShort | null>(null);

  ngOnInit() {
    const offerId = Number(this.activateRoute.snapshot.paramMap.get('id'));
    this.loadDataCaseToken();

    if (!isNaN(offerId)) {
      this.accomService
        .getOffers()
        .pipe(
          map(offers => {
            const matchedOffer = offers.find(
              o => String(o.id) === String(offerId)
            );
            this.offer.set(matchedOffer ?? null);
          }),
          catchError(err => {
            console.error('Failed to load offers', err);
            this.isErrorRequest.set(true);
            this.errorMessage.set(err?.error.errors?.[0]?.params?.[0]);
            return of(null);
          })
        )
        .subscribe();
    }
  }

  public goToSubmitPage() {
    this.router.navigate(['/confirmation-success'], {
      queryParams: { caseToken: this.caseToken() },
    });
  }

  public backToMainPage() {
    history.back();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogWarningConfirmComponent, {
      maxWidth: '700px',
      data: this.offer(),
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.confirmedOffer.set(result);
        this.accomService
          .confirmOffer(result.id)
          .pipe(
            tap(() => {
              this.goToSubmitPage();
            }),
            catchError(err => {
              this.snackBar.open(
                'Failed to confirm offer. Please try again.',
                'Close',
                {
                  duration: 4000,
                  panelClass: ['snackbar-error'],
                }
              );
              return of(null);
            })
          )
          .subscribe();
      }
    });
  }

  private loadDataCaseToken(): void {
    const token = this.activateRoute.snapshot.queryParamMap.get('caseToken');
    this.caseToken.set(token!);
    if (this.caseToken) {
      this.accomService.setCaseToken(this.caseToken());
    }
  }
}
